import { useMutation } from "@tanstack/react-query";
import { get_download_link } from "../../service/query/auth";
import { toast } from "react-toastify";


export const useGetDownloadLink = () => {
  return useMutation({
    mutationFn: get_download_link,
    onSuccess: (data) => {
      

      return;
    },
    onError: (error) => {
      console.error(" error:", error);
      toast(error?.response?.data?.message || "An error occurred");
      return;
    },
  });
};
